import { fetchChildExtracurricular, fetchAttendanceDay, fetchAttendanceMonth, fetchChildren, fetchChildSchedule, fetchChildHistory, fetchAllExtracurricular, fetchCurrentTopics, createStudentLeaves, fetchStudentLeaves, fetchBehaviourRecords, fetchCounselingAttendance, fetchFeesPayment, feesPaymentTransaction, homeworkList, uploadHomework, setWalletLimit, fetchBills, billPayment, billPaymentVA, fetchSubjectAttendance, eraportSettings, academicYears, submitParentResponse, eraportSubjectScore, studentLearningReport, quranJuz, tahfidz, events, createCombinedInvoice } from "@/services/childrenService";

const state = {
    children: [],    // Menyimpan semua data anak yang di-fetch
    selectedChild: null, // Menyimpan data anak yang dipilih
    childSchedule: [],
    childAttendanceMonth: [],
    childAttendanceDay: [],
    childHistory: [],
    childExtracurricular: [],
    allExtracurricular: [],
    izin: [],
    behaviourRecords: [],
    counselingAttendance: [],
    feesPayment: [],
    homeworkList: [], // Menyimpan daftar PR
    eraportSettings: null, // Menyimpan pengaturan eraport
    academicYears: [],
    eraportSubjectScores: [],
    studentLearningReport: [],
    error: null,
    loadingCount: 0,
    bills: [],
    subjectAttendance: [], // Menyimpan data kehadiran per mata pelajaran
    quranJuz: [],
    tahfidz: [],
    behaviourCoachingScore: [],
    followUpBehaviour: [],
    behaviourPoint: 0, // Menyimpan total poin perilaku,
    events: []
};

const mutations = {
    SET_CHILDREN(state, children) {
        state.children = children;
    },
    SET_SELECTED_CHILD(state, child) {
        state.selectedChild = child;
    },
    SET_CHILD_SCHEDULE(state, childSchedule) {
        state.childSchedule = childSchedule;
    },
    SET_CHILD_ATTENDANCE_MONTH(state, childAttendanceMonth) {
        state.childAttendanceMonth = childAttendanceMonth;
    },
    SET_CHILD_ATTENDANCE_DATE(state, childAttendanceDay) {
        state.childAttendanceDay = childAttendanceDay;
    },
    SET_CHILD_HISTORY(state, childHistory) {
        state.childHistory = childHistory;
    },
    SET_CHILD_EXTRACURRICULAR(state, childExtracurricular) {
        state.childExtracurricular = childExtracurricular;
    },
    SET_ALL_EXTRACURRICULAR(state, allExtracurricular) {
        state.allExtracurricular = allExtracurricular;
    },
    SET_IZIN(state, izin) {
        state.izin = izin
    },
    SET_BEHAVIOUR_RECORDS(state, behaviourRecords) {
        state.behaviourRecords = behaviourRecords;
    },
    SET_COUNSELING_ATTENDANCE(state, counselingAttendance) {
        state.counselingAttendance = counselingAttendance;
    },
    SET_FEES_PAYMENT(state, feesPayment) {
        state.feesPayment = feesPayment;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
    SET_LOADING(state, loading) {
        state.loading = loading;
    },
    SET_HOMEWORK_LIST(state, homeworkList) {
        state.homeworkList = homeworkList;
    },
    SET_BILLS(state, bills) {
        state.bills = bills
    },
    SET_SUBJECT_ATTENDANCE(state, subjectAttendance) {
        state.subjectAttendance = subjectAttendance;
    },
    SET_ACADEMIC_YEARS(state, academicYears) {
        state.academicYears = academicYears;
    },
    SET_ERAPORT_SETTINGS(state, eraportSettings) {
        state.eraportSettings = eraportSettings;
    },
    SET_ERAPORT_SUBJECT_SCORES(state, eraportSubjectScores) {
        state.eraportSubjectScores = eraportSubjectScores;
    },
    SET_STUDENT_LEARNING_REPORT(state, studentLearningReport) {
        state.studentLearningReport = studentLearningReport;
    },
    SET_QURAN_JUZ(state, quranJuz) {
        state.quranJuz = quranJuz;
    },
    SET_TAHFIDZ(state, tahfidz) {
        state.tahfidz = tahfidz;
    },
    INCREMENT_LOADING(state) {
        state.loadingCount++;
        state.loading = true;
    },
    DECREMENT_LOADING(state) {
        if (state.loadingCount > 0) {
            state.loadingCount--;
        }
        if (state.loadingCount === 0) {
            state.loading = false;
        }
    },
    RESET_ALL_CHILD_STATE(state) {
        state.children = [];
        state.selectedChild = null;
        state.childSchedule = [];
        state.childAttendanceMonth = [];
        state.childAttendanceDay = [];
        state.childHistory = [];
        state.childExtracurricular = [];
        state.allExtracurricular = [];
        state.izin = [];
        state.behaviourRecords = [];
        state.counselingAttendance = [];
        state.feesPayment = [];
        state.homeworkList = [];
        state.eraportSettings = null;
        state.academicYears = [];
        state.eraportSubjectScores = [];
        state.studentLearningReport = [];
        state.error = null;
        state.bills = [];
        state.subjectAttendance = [];
        state.loadingCount = 0;
        state.loading = false;
        state.quranJuz = [];
    },
    SET_BEHAVIOUR_COACHING_SCORE(state, behaviourCoachingScore) {
        state.behaviourCoachingScore = behaviourCoachingScore;
    },
    SET_FOLLOW_UP_BEHAVIOUR(state, followUpBehaviour) {
        state.followUpBehaviour = followUpBehaviour;
    },
    SET_BEHAVIOUR_POINT(state, behaviourPoint) {
        state.behaviourPoint = behaviourPoint;
    },
    SET_EVENTS(state, events) {
        state.events = events;
    }
};

const actions = {
    async fetchChildren({ commit }, user_id) {
        try {
            const children = await fetchChildren(user_id);
            commit('SET_CHILDREN', children);
        } catch (error) {
            commit('SET_ERROR', error.message);
        }
    },
    // selectChild({ commit, state }, child_id) {
    //     const child = state.children.find(child => child.id === child_id); 
    //     commit('SET_SELECTED_CHILD', child);
    // },
    async childSchedule({ commit }, child_id) {
        try {
            const schedule = await fetchChildSchedule(child_id);
            
            commit('SET_CHILD_SCHEDULE', schedule);
        } catch (error) {
            commit('SET_ERROR', error.message);
        }
    },
    async childAttendanceMonth({ commit }, data) {
        try {
            
            commit('SET_CHILD_ATTENDANCE_MONTH', []);
            const childAttendanceMonth = await fetchAttendanceMonth(data.id, data.month, data.year);
            commit('SET_CHILD_ATTENDANCE_MONTH', childAttendanceMonth);
        } catch (error) {
            commit('SET_ERROR', error.message);
        }
    },
    async childAttendanceDay({ commit }, { child_id, fulldate }) {
        try {
            commit('SET_CHILD_ATTENDANCE_DATE', []);
            const childAttendanceMonth = await fetchAttendanceDay(child_id, fulldate);
            commit('SET_CHILD_ATTENDANCE_DATE', childAttendanceMonth);
        } catch (error) {
            commit('SET_ERROR', error.message);
        }
    },
    async fetchChildHistory({ commit }, child_id) {
        try {
            const childHistory = await fetchChildHistory(child_id);
            commit('SET_CHILD_HISTORY', childHistory);
        } catch (error) {
            commit('SET_ERROR', error.message);
        }
    },
    resetAllChildState({ commit }) {
        commit('RESET_ALL_CHILD_STATE');
    },
    resetChildHistory({ commit }) {
        commit('SET_CHILD_HISTORY', [])
    },
    async fetchChildExtracurricular({ commit }, student_id) {
        try {
            const childExtracurricular = await fetchChildExtracurricular(student_id);
            commit('SET_CHILD_EXTRACURRICULAR', childExtracurricular);
        } catch (error) {
            commit('SET_ERROR', error.message);
        } finally {
            commit('DECREMENT_LOADING');
        }
    },
    async fetchAllExtracurricular({ commit }) {
        try {
            const allExtracurricular = await fetchAllExtracurricular();
            commit('SET_ALL_EXTRACURRICULAR', allExtracurricular);
        } catch (error) {
            commit('SET_ERROR', error.message);
        } finally {
            commit('DECREMENT_LOADING');
        }
    },
    async getCurrentTopics({ commit }, data) {
        try {
            const response = await fetchCurrentTopics(data);
            
            return response.data;
        } catch (error) {
            commit('SET_ERROR', error.message);
        }
    },
    async createStudentLeaves({commit}, data) {
        try {
            const response = await createStudentLeaves(data)
            
            return response;
        } catch (error) {
            commit('SET_ERROR', error.message);
        }
    },
    async getStudentLeaves({commit}, student_id) {
        try {
            const response = await fetchStudentLeaves(student_id)
            
            commit('SET_IZIN', response);
        } catch (error) {
            commit('SET_ERROR', error.message);
        }
    },
    async fetchBehaviourRecords({commit}, student_id) {
        try {
            const response = await fetchBehaviourRecords(student_id)
            
            commit('SET_BEHAVIOUR_RECORDS', response.behaviourRecord);
            commit('SET_BEHAVIOUR_COACHING_SCORE', response.behaviourCoachingScore);
            commit('SET_FOLLOW_UP_BEHAVIOUR', response.lmsFollowUpBehaviour);
            commit('SET_BEHAVIOUR_POINT', response.totalPoint)
        } catch (error) {
            commit('SET_ERROR', error.message);
        }
    },
    async fetchCounselingAttendance({ commit }, student_id) {
        try {
            const response = await fetchCounselingAttendance(student_id);
            
            commit('SET_COUNSELING_ATTENDANCE', response);
        } catch (error) {
            commit('SET_ERROR', error.message);
        }
    },
    async fetchFeesPayment({ commit }, student_id) {
        try {
            const response = await fetchFeesPayment(student_id);
            
            commit('SET_FEES_PAYMENT', response);
        } catch (error) {
            commit('SET_ERROR', error.message);
        }
    },
    async payTransaction({ commit }, data) {
        try {
            const response = await feesPaymentTransaction(data.fees_id, data.data);
            console.log(response);
            
        } catch (error) {
            commit('SET_ERROR', error.message);
        }
    },
    async fetchHomeworkList({commit}, student_id) {
        try {
            commit('SET_HOMEWORK_LIST', []);

            const response = await homeworkList(student_id);
            
            commit('SET_HOMEWORK_LIST', response);
        } catch (error) {
            commit('SET_ERROR', error.message);
        }
    },
    async uploadHomework({commit}, { student_id, data }) {
        try {
            const response = await uploadHomework(student_id, data);
            return response;
        } catch (error) {
            commit('SET_ERROR', error.message);
            throw error;
        }
    },
    async setWalletLimit({commit}, { user_id, data }) {
        try {
            const response = await setWalletLimit(user_id, data);
            return response;
        } catch (error) {
            commit('SET_ERROR', error.message);
        }
    },
    async fetchBills({commit}, user_id) {
        try {
            commit('SET_BILLS', []);
            
            const response = await fetchBills(user_id);
            
            commit('SET_BILLS', response);
        } catch (error) {
            commit('SET_ERROR', error.message);
        }
    },
    async payBill({commit}, data) {    
        try {
            const response = await billPayment(data.userId, data.billId, data.amount);

            return response;
        } catch (error) {
            commit('SET_ERROR', error.message);
            throw error;
        }
    },
    async payBillVA({commit}, data) {    
        try {
            const response = await billPaymentVA(data.userId, data.billId, data.amount, data.isNative, data.redirectUrl);

            return response;
        } catch (error) {
            commit('SET_ERROR', error.message);
            throw error;
        }
    },
    async createCombinedInvoice({commit}, data) {
        try {
            const response = await createCombinedInvoice(data.userId, data.billIds, data.isNative, data.redirectUrl);

            return response;
        } catch (error) {
            commit('SET_ERROR', error.message);
            throw error;
        }
    },
    async fetchSubjectAttendance({commit}, student_id) {
        try {
            const response = await fetchSubjectAttendance(student_id);
            commit('SET_SUBJECT_ATTENDANCE', response);
        } catch (error) {
            commit('SET_ERROR', error.message);
            throw error;
        }
    },
    async fetchEraportSettings({ commit }, { student_id, academic_id, semester_id }) {
        try {
            const response = await eraportSettings(student_id, academic_id, semester_id);
            commit('SET_ERAPORT_SETTINGS', response);
        } catch (error) {
            commit('SET_ERROR', error.message);
            throw error;
        }
    },
    async fetchAcademicYears({commit}) {
        try {
            const response = await academicYears();
            commit('SET_ACADEMIC_YEARS', response);
        } catch (error) {
            commit('SET_ERROR', error.message);
            throw error;
        }
    },
    async submitParentResponse({ commit }, { student_id, academic_id, semester_id, response }) {
        try {
            const result = await submitParentResponse(student_id, academic_id, semester_id, response);
            return result;
        } catch (error) {
            commit('SET_ERROR', error.message);
            throw error;
        }
    },
    async fetchEraportSubjectScore({ commit }, { student_id, academic_id, semester_id, score_type }) {
        try {
            const response = await eraportSubjectScore(student_id, academic_id, semester_id, score_type);
            commit('SET_ERAPORT_SUBJECT_SCORES', response);
        } catch (error) {
            commit('SET_ERROR', error.message);
            throw error;
        }
    },
    async fetchStudentLearningReport({ commit }, { student_id, academic_id, semester_id }) {
        try {
            const response = await studentLearningReport(student_id, academic_id, semester_id);
            commit('SET_STUDENT_LEARNING_REPORT', response);
        } catch (error) {
            commit('SET_ERROR', error.message);
            throw error;
        }
    },
    async fetchQuranJuz({commit}, {student_id}) {
        try {
            const response = await quranJuz(student_id);
            commit('SET_QURAN_JUZ', response);
        } catch (error) {
            commit('SET_ERROR', error.message);
            throw error;
        }
    },
    async fetchTahfidz({commit}, { student_id, juz_id }) {
        try {
            const response = await tahfidz(student_id, juz_id);
            commit('SET_TAHFIDZ', response);
        } catch (error) {
            commit('SET_ERROR', error.message);
            throw error;
        }
    },
    async fetchEvents({commit}, {year, month, student_id}) {
        try {
            const response = await events(year, month, student_id);
            
            commit('SET_EVENTS', response);
        } catch (error) {
            commit('SET_ERROR', error.message);
            throw error;
        }
    }
};

const getters = {
    getAllChildren: state => state.children,
    getSelectedChild: state => state.selectedChild,
    getChildSchedule: state => state.childSchedule,
    getChildAttendanceMonth: state => state.childAttendanceMonth,
    getChildAttendanceDay: state => state.childAttendanceDay,
    getChildHistory: state => state.childHistory,
    getIsLoading: state => state.loading,
    getChildExtracurricular: state => state.childExtracurricular,
    getAllExtracurricular: state => state.allExtracurricular,
    getStudentLeaves: state => state.izin,
    getBehaviourRecords: state => state.behaviourRecords,
    getCounselingAttendance: state => state.counselingAttendance,
    getFeesPayment: state => state.feesPayment,
    getHomeworkList: state => state.homeworkList,
    getBills: state => state.bills,
    getSubjectAttendance: state => state.subjectAttendance,
    getEraportSettings: state => state.eraportSettings,
    getAcademicYears: state => state.academicYears,
    getEraportSubjectScores: state => state.eraportSubjectScores,
    getStudentLearningReport: state => state.studentLearningReport,
    getQuranJuz: state => state.quranJuz,
    getTahfidz: state => state.tahfidz,
    getBehaviourCoachingScore: state => state.behaviourCoachingScore,
    getFollowUpBehaviour: state => state.followUpBehaviour,
    getBehaviourPoint: state => state.behaviourPoint,
    getEvents: state => state.events
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
